import { PageWrapper } from "../PageWrapper";
import s from "./style.module.scss";
import { ListCheckmark } from "../ListCheckmark";
import { useSectionsData } from "../../utils/useSectionsData.ts";
import { getBrandName } from "../../utils/helpers.ts";
import glideImage from "../../utils/useGlideImage.ts";

export const JoinSubscribersSection = () => {
  const brandName = getBrandName();
  const sections = useSectionsData();
  const socBenefitsSection = sections?.pp_v7_social_benefits_section;
  const heading = socBenefitsSection?.tr_heading;
  const description = socBenefitsSection?.tr_description;
  const benefits = socBenefitsSection?.benefits_repeater;

  return (
    <PageWrapper>
      <div className={s.joinSubscribersSection}>
        <div className={s.joinSubscribersSection__left}>
          <img
            src={glideImage(socBenefitsSection.section_image, {
              w: 552,
              h: 552,
            })}
            width={552}
            height={552}
            alt={brandName}
          />
        </div>
        <div className={s.joinSubscribersSection__right}>
          <h4 className={s.joinSubscribersSection__title}>{heading}</h4>
          <p
            className={s.joinSubscribersSection__description}
            dangerouslySetInnerHTML={{ __html: description }}
          />
          <ul>
            {benefits &&
              benefits?.map(
                (benefit: { tr_benefit_text: string }, index: number) => (
                  <ListCheckmark
                    dangerousHTML={benefit.tr_benefit_text}
                    key={index}
                  ></ListCheckmark>
                )
              )}
          </ul>
        </div>
      </div>
    </PageWrapper>
  );
};
